(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebd-global-announcement"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.global-announcement .swiper', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 500,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-hp-about"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const video  = document.getElementById('aboutVideo');
  const toggle = document.getElementById('videoToggle');
  if (!video || !toggle) return;

  const playIcon  = toggle.querySelector('.icon-play');
  const pauseIcon = toggle.querySelector('.icon-pause');

  let firstClickDone = false;

  const setIcons = (isPlaying) => {
    if (isPlaying) {
      playIcon.classList.add('hidden');
      pauseIcon.classList.remove('hidden');
      toggle.setAttribute('aria-label','Pause video');
    } else {
      playIcon.classList.remove('hidden');
      pauseIcon.classList.add('hidden');
      toggle.setAttribute('aria-label','Play video');
    }
  };

  // Ensure initial state
  video.muted = true;

  // Attach the source only when needed, so the video is not downloaded on page load.
  const loadVideo = () => {
    if (video.getAttribute('src')) return;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    video.src = (isMobile ? video.dataset.srcMobile : video.dataset.srcDesktop) || video.dataset.srcDesktop;
  };

  // Autoplay (muted) while the video is on screen, pause when it scrolls away. Once the user has
  // taken control with the toggle, leave playback to them.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (firstClickDone) return;
        if (entry.isIntersecting) {
          loadVideo();
          video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' }).observe(video);
  } else {
    loadVideo();
    video.play().catch(() => {});
  }

  toggle.addEventListener('click', () => {
    loadVideo();
    // FIRST CLICK: restart from beginning and unmute (even though it's already playing muted)
    if (!firstClickDone) {
      video.pause();               // ensure we can safely jump to 0
      video.currentTime = 0;       // restart
      video.muted = false;         // unmute on user gesture
      video.play();
      firstClickDone = true;
      setIcons(true);
      return;
    }

    // AFTER FIRST CLICK: normal pause/mute ↔ play/unmute behavior
    if (video.paused) {
      video.muted = false;         // resume unmuted
      video.play();
      setIcons(true);
    } else {
      video.pause();
      video.muted = true;          // pause and mute
      setIcons(false);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-hp-benefits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const benefits = document.querySelectorAll('[data-benefit]');

  benefits.forEach(benefit => {
    benefit.addEventListener('click', () => {
      if (window.innerWidth <= 1024) {
        benefits.forEach(b => {
          if (b !== benefit) b.classList.remove('active');
        });
        benefit.classList.toggle('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-hp-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.hp-faqs .faq-single');

    faqItems.forEach(function(item) {
      const toggle = item.querySelector('.faq-toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function() {
        item.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-hp-instructions"] && !Shopify.designMode) return;
  try {
    
  const toggleButtons = document.querySelectorAll('.instructions-toggle');
  const instructionWrappers = document.querySelectorAll('.instruction-wrapper');
  const instructionSelect = document.querySelector('.instructions-select');

  // Hide all instruction wrappers initially except the first one
  instructionWrappers.forEach((wrapper, index) => {
    if (index !== 0) {
      wrapper.style.display = 'none';
    }
  });

  // Set first button as active
  if (toggleButtons.length > 0) {
    toggleButtons[0].classList.add('active');
  }

  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.dataset.id;
      
      // Remove active class from all buttons
      toggleButtons.forEach(btn => btn.classList.remove('active'));
      
      // Add active class to clicked button
      this.classList.add('active');
      
      // Hide all instruction wrappers
      instructionWrappers.forEach(wrapper => {
        wrapper.style.display = 'none';
      });
      
      // Show the target instruction wrapper
      const targetWrapper = document.querySelector(`.instruction-wrapper[data-id="${targetId}"]`);
      if (targetWrapper) {
        targetWrapper.style.display = 'grid';
      }
    });
  });

  // Handle select change for mobile
  if (instructionSelect) {
    instructionSelect.addEventListener('change', function() {
      const targetId = this.value;
      
      // Hide all instruction wrappers
      instructionWrappers.forEach(wrapper => {
        wrapper.style.display = 'none';
      });
      
      // Show the target instruction wrapper
      const targetWrapper = document.querySelector(`.instruction-wrapper[data-id="${targetId}"]`);
      if (targetWrapper) {
        targetWrapper.style.display = 'grid';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-hp-product-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.ebd-hp-product-cards .swiper', {
      slidesPerView: 1.15,
      spaceBetween: 15,
      scrollbar: {
        el: '.ebd-hp-product-cards .swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        1400: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 3.25
        },
        1000: {
          slidesPerView: 2.85
        },
        800: {
          slidesPerView: 2.25
        },
        600: {
          slidesPerView: 1.85
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-hp-video-collection-grid"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.ebd-video-collection-grid .swiper', {
    slidesPerView: 1.45,
    spaceBetween: 15,
    scrollbar: {
      el: '.ebd-video-collection-grid .swiper-scrollbar',
      draggable: true
    },
    breakpoints: {

      1200: {
        slidesPerView: 5.25
      },
      1000: {
        slidesPerView: 4.5
      },
      700: {
        slidesPerView: 3.25,
        spaceBetween: 15
      },
      500: {
        slidesPerView: 2.25,
        spaceBetween: 15
      }
    }
  });

  document.querySelectorAll('.ebd-video-collection-grid .slide-wrapper').forEach(function(wrapper) {
    const video = wrapper.querySelector('video');
    const mediaWrapper = wrapper.querySelector('.media-wrapper');

    wrapper.addEventListener('mouseenter', function() {
      if (video) {
        video.currentTime = 0;
        video.play();
        mediaWrapper.classList.add('playing');
      }
    });

    wrapper.addEventListener('mouseleave', function() {
      if (video) {
        video.pause();
        video.currentTime = 0;
        mediaWrapper.classList.remove('playing');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-pdp-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.faq-item');

    items.forEach(item => {
      const question = item.querySelector('.faq-question');
      const toggle = item.querySelector('.faq-toggle');
      const answer = item.querySelector('.faq-answer');

      question.addEventListener('click', e => {
        e.preventDefault();

        const isOpen = item.classList.contains('open');
        item.classList.toggle('open');
        toggle.setAttribute('aria-expanded', !isOpen);
        answer.classList.toggle('show');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-product-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.ebd-product-cards .swiper', {
      slidesPerView: 1.15,
      spaceBetween: 15,
      scrollbar: {
        el: '.ebd-product-cards .swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        1400: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 3.25
        },
        1000: {
          slidesPerView: 2.85
        },
        800: {
          slidesPerView: 2.25
        },
        600: {
          slidesPerView: 1.85
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-product-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const ingredientSelect = document.getElementById('ingredient-select');
    const ingredientButtons = document.querySelectorAll('.ingredient-button');
    const ingredientContents = document.querySelectorAll('.ingredient-content');

    function setActiveIngredient(index) {
      ingredientButtons.forEach((button) => button.classList.remove('is-active'));
      if (ingredientButtons[index]) ingredientButtons[index].classList.add('is-active');

      ingredientContents.forEach((content) => content.classList.add('is-hidden'));
      if (ingredientContents[index]) ingredientContents[index].classList.remove('is-hidden');

      if (ingredientSelect && String(ingredientSelect.value) !== String(index)) {
        ingredientSelect.value = String(index);
      }
    }

    if (ingredientSelect) {
      ingredientSelect.addEventListener('change', function () {
        setActiveIngredient(parseInt(this.value, 10));
      });
    }

    ingredientButtons.forEach((button) => {
      button.addEventListener('click', function () {
        setActiveIngredient(parseInt(this.getAttribute('data-index'), 10));
      });
    });

    setActiveIngredient(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-product-main-zoom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperEl = document.querySelector('.ebd-media-mobile .swiper');
    if (swiperEl) {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
          el: '.ebd-media-mobile .swiper-scrollbar',
          draggable: true,
          clickable: true,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.ebd-media-mobile .swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,

      scrollbar: {
        el: '.ebd-media-mobile .swiper-scrollbar',
        draggable: true,
        clickable: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Mobile Accordions
    const mobileAccordions = document.getElementById('mobile-accordions');
    if (mobileAccordions) {
      const mobileButtons = mobileAccordions.querySelectorAll('#mobile-accordions button');

      mobileButtons.forEach((button, index) => {
        const contentId = `mobile-accordion-content-${index + 1}`;
        button.setAttribute('id', `mobile-accordion-button-${index + 1}`);
        button.setAttribute('aria-controls', contentId);

        button.addEventListener('click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          const content = document.getElementById(contentId);

          // Close all accordions
          mobileButtons.forEach((btn) => {
            const btnContent = document.getElementById(btn.getAttribute('aria-controls'));
            btn.setAttribute('aria-expanded', 'false');

            const icon = btn.querySelector('.ebd-product-tabs__accordion-icon');
            if (icon) icon.textContent = '+';

            if (btnContent) btnContent.classList.add('hidden');
          });

          // Toggle current accordion
          if (!isExpanded) {
            button.setAttribute('aria-expanded', 'true');

            const icon = button.querySelector('.ebd-product-tabs__accordion-icon');
            if (icon) icon.textContent = '-';

            if (content) content.classList.remove('hidden');
          }
        });

        button.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            button.click();
          }
        });
      });
    }

    // Desktop Tabs
    const desktopTabs = document.getElementById('desktop-tabs');
    if (desktopTabs) {
      const tabButtons = desktopTabs.querySelectorAll('[role="tab"]');
      const tabPanels = desktopTabs.querySelectorAll('[role="tabpanel"]');

      tabButtons.forEach((button, index) => {
        const panelId = `tab-pane-desktop-${index + 1}`;
        button.setAttribute('id', `tab-desktop-button-${index + 1}`);
        button.setAttribute('aria-controls', panelId);
        button.setAttribute('tabindex', index === 0 ? '0' : '-1');

        button.addEventListener('click', () => {
          // Deactivate all tabs
          tabButtons.forEach((btn) => {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-selected', 'false');
            btn.setAttribute('tabindex', '-1');
          });

          tabPanels.forEach((panel) => {
            panel.classList.add('hidden');
          });

          // Activate clicked tab
          button.classList.add('is-active');
          button.setAttribute('aria-selected', 'true');
          button.setAttribute('tabindex', '0');

          // Show selected panel
          if (tabPanels[index]) tabPanels[index].classList.remove('hidden');
        });

        button.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            const newIndex = (index + 1) % tabButtons.length;
            tabButtons[newIndex].focus();
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            const newIndex = (index - 1 + tabButtons.length) % tabButtons.length;
            tabButtons[newIndex].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            tabButtons[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            tabButtons[tabButtons.length - 1].focus();
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-subscriptions-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function () {
        const parent = this.parentElement;
        const iconOpen = this.querySelector('.toggle-icon');
        const iconClose = this.querySelector('.toggle-icon-close');
        const isActive = parent.classList.contains('active');

        if (isActive) {
          iconOpen.style.display = 'block';
          iconClose.style.display = 'none';
        } else {
          iconOpen.style.display = 'none';
          iconClose.style.display = 'block';
        }

        parent.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-subscriptions-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper('.ebd-sub-review-slider .swiper-container', {
      slidesPerView: 1.05,
      spaceBetween: 15,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      breakpoints: {
        450: {
          slidesPerView: 1.25
        },
        650: {
          slidesPerView: 1.65,
          spaceBetween: 25
        },
        800: {
          slidesPerView: 2.05,
          spaceBetween: 20
        },
        1100: {
          slidesPerView: 3.5
        },
        1400: {
          slidesPerView: 4.05,
          spaceBetween: 25
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mush-lp-dropdowns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function () {
        const dropdownContent = this.nextElementSibling;

        this.classList.toggle('active');
        dropdownContent.classList.toggle('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mush-lp-recipes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.mushroom-lp-recipes .toggle');
    const recipes = document.querySelectorAll('.mushroom-lp-recipes .recipe');

    toggles.forEach((toggle, index) => {
      toggle.addEventListener('click', function() {
        // Remove active class from all toggles and recipes
        toggles.forEach(t => t.classList.remove('active'));
        recipes.forEach(r => r.classList.remove('active'));

        // Add active class to the clicked toggle and corresponding recipe
        toggle.classList.add('active');
        recipes[index].classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-hp-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  var testimonialSwiper = new Swiper('.hp-video-testimonials .swiper', {
    slidesPerView: 1.15,
    spaceBetween: 15,
    breakpoints: {
      500: {
        slidesPerView: 1.85,
      },
      700: {
        slidesPerView: 2.15,
      },
      900: {
        slidesPerView: 3.15,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      },
    },
  });

var wrappers = document.querySelectorAll('.hp-video-testimonials .slide-wrapper');

function resetWrapper(w) {
  var v = w.querySelector('video');
  if (!v) return;
  v.pause();
  try { v.currentTime = 0; } catch(e) {}
  v.load(); // forces the poster to show again
  var play = w.querySelector('.video-control .play');
  var pause = w.querySelector('.video-control .pause');
  if (pause) pause.style.display = 'none';
  if (play) play.style.display = 'block';
}

wrappers.forEach(function(wrapper) {
  var video = wrapper.querySelector('video');
  var videoControl = wrapper.querySelector('.video-control');
  var playBtn = wrapper.querySelector('.video-control .play');
  var pauseBtn = wrapper.querySelector('.video-control .pause');

  // Show poster again when the video ends
  video.addEventListener('ended', function() {
    resetWrapper(wrapper);
  });

  videoControl.addEventListener('click', function() {
    if (video.paused) {
      // Pause and reset every other slide to its poster
      wrappers.forEach(function(otherWrapper) {
        if (otherWrapper !== wrapper) resetWrapper(otherWrapper);
      });
      playBtn.style.display = 'none';
      pauseBtn.style.display = 'block';
      video.play();
    } else {
      pauseBtn.style.display = 'none';
      playBtn.style.display = 'block';
      video.pause();
    }
  });
});

testimonialSwiper.on('slideChangeTransitionStart', function() {
  wrappers.forEach(resetWrapper);
});




  } catch(e) { console.error(e); }
})();
})();
